import {application} from '@/settings';

export const useApplicationSettings = () => {
  return application;
};
